module.exports = __webpack_public_path__ + "static/media/histogramChartTitleHandle.b78f16f7.svg";